import { getMedias } from '../../../app/api';
import { PRODUCT_DEFAULT_IMAGE } from '../../medias/public';
import { isImageMimeOrExtension } from '../../medias/public/mediaMime';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export function productImageUrlFromMap(productId, imageMap) {
  if (!productId) return PRODUCT_DEFAULT_IMAGE;
  return imageMap?.[productId] || PRODUCT_DEFAULT_IMAGE;
}

export function buildProductImageMapFromMedias(medias, productIds) {
  const imagesMap = {};
  const idSet = productIds ? new Set(productIds) : null;
  const allMedias = Array.isArray(medias) ? medias : [];

  allMedias.forEach((media) => {
    if (!media.metadata?.length || !media.file_path) return;

    media.metadata.forEach((meta) => {
      if (meta.key !== 'product_image') return;
      if (!isImageMimeOrExtension(media.mime_type, media.filename)) return;
      const metaValue = meta.value;
      const isObject = typeof metaValue === 'object' && metaValue !== null;
      const productId = isObject ? metaValue.id : metaValue;
      if (!productId || (idSet && !idSet.has(productId))) return;

      const order = isObject ? metaValue?.order || 0 : 0;
      const url = `${API_URL}${media.file_path}`;
      const current = imagesMap[productId];
      if (!current || order < current.order) {
        imagesMap[productId] = { url, order };
      }
    });
  });

  return Object.fromEntries(
    Object.entries(imagesMap).map(([productId, entry]) => [productId, entry.url]),
  );
}

let cachedImageMap = null;
let cachePromise = null;

export async function fetchProductImageMap(productIds) {
  if (cachedImageMap && !productIds) return cachedImageMap;
  if (!cachePromise || productIds) {
    cachePromise = getMedias()
      .then((res) => {
        const medias = res?.data?.medias || res?.data || [];
        const map = buildProductImageMapFromMedias(medias, productIds);
        if (!productIds) cachedImageMap = map;
        return map;
      })
      .catch(() => ({}));
  }
  return cachePromise;
}
